module.exports = __webpack_public_path__ + "img/0753-Ginestar.3617fc6e.jpeg";